export const GetCustomRelatedProducts = `
  query GetRelatedProducts($filter: ProductAttributeFilterInput) {
    products(filter: $filter) {
      items {
        sku
        name
        related_products {
          uid
          __typename
          sku
          name
          stock_status
          only_x_left_in_stock
          hideprice
          category_image
          thumbnail{
            url
            position
            disabled
            label
            __typename
          }
          url_key
          url_rewrites {
            url
            __typename
          }
          price_range {
            maximum_price {
              final_price {
                currency
                value
              }
              regular_price {
                currency
                value
              }
            }
            minimum_price {
              final_price {
                currency
                value
              }
              regular_price {
                currency
                value
              }
            }
          }
        }
      }
    }
  }
`;
